document.addEventListener('DOMContentLoaded', () => {
  const showDrawerEl = document.getElementById('drawer-show');
  const closeDrawerEl = document.getElementById('drawer-close');
  const drawerWrapperEl = document.querySelector('.drawer__col--aside');

  if (showDrawerEl !== null && showDrawerEl !== undefined) {
    const showCatalog = (e) => {
      drawerWrapperEl.classList.add('_show');
    };
    showDrawerEl.addEventListener('click', showCatalog);

    const hideCatalog = () => {
      drawerWrapperEl.classList.remove('_show');
    };
    closeDrawerEl.addEventListener('click', hideCatalog);
    clickAwayListener = (event) => {
      function checkIfNodeListContainsElement(list, target) {
        let flag = false;
        for (let index = 0; index < list.length; index++) {
          const element = list[index];
          if (target === element || element.contains(target)) flag = true;
        }
        return flag;
      }
      if (
        event.target !== drawerWrapperEl &&
        !drawerWrapperEl.contains(event.target) &&
        !checkIfNodeListContainsElement(showDrawerEl, event.target)
      ) {
        hideCatalog();
      }
    };
    document.addEventListener('click', { handleEvent: clickAwayListener }, true);
  }
});
